// rg-gallery-height: en mobile, las primeras 2 fotos del carrusel de producto
// miden la mitad de ancho (ver .rg-media-pair en base.css), asi que quedan
// mas cortas que el resto. El contenedor del carrusel no se achica solo
// (flexbox no reduce el alto de sus hermanos por defecto), asi que esta
// pieza ajusta el alto del contenedor a la diapositiva que esta centrada en
// pantalla en este momento, para que los botones de compra (que van debajo)
// suban o bajen segun corresponda.
//
// No depende de eventos propios del componente del carrusel del tema (su
// nombre/timing exacto no esta garantizado) -- calcula directamente, a
// partir de la posicion real de scroll, cual diapositiva esta centrada.
// Esto es exactamente lo que pasa cuando alguien desliza con el dedo.
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  // El propio slide tiene "max-height: 100%" (se ajusta al alto del
  // contenedor), asi que su alto renderizado no sirve para saber cuanto
  // "querria" medir. El ancho si es confiable (no depende del alto del
  // contenedor), asi que el alto real se calcula desde ahi.
  function slideRatio(slide) {
    if (slide.classList.contains('rg-media-pair')) return 1;
    var raw = slide.style.getPropertyValue('--media-preview-ratio');
    var ratio = parseFloat(raw);
    return ratio > 0 ? ratio : 1;
  }

  // El ancho se calcula desde el CONTENEDOR (siempre visible), no desde la
  // propia diapositiva -- si esta fuera de pantalla el navegador puede
  // demorar su layout, y medirla directamente puede dar un ancho viejo o 0
  // justo en el momento en que cambiamos a ella.
  function naturalHeight(scroller, slide) {
    var scrollerWidth = scroller.getBoundingClientRect().width;
    if (!scrollerWidth) return 0;
    var width = slide.classList.contains('rg-media-pair') ? scrollerWidth / 2 : scrollerWidth;
    return width / slideRatio(slide);
  }

  // Diapositiva cuyo centro esta mas cerca del centro del contenedor visible.
  function centeredSlide(scroller, slides) {
    var scrollerRect = scroller.getBoundingClientRect();
    var target = scrollerRect.left + scrollerRect.width / 2;
    var best = null;
    var bestDistance = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var rect = slides[i].getBoundingClientRect();
      if (rect.width === 0) continue;
      var slideCenter = rect.left + rect.width / 2;
      var distance = Math.abs(slideCenter - target);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = slides[i];
      }
    }

    return best;
  }

  function init(gallery) {
    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller) return;

    var slides = Array.prototype.slice.call(scroller.querySelectorAll('slideshow-slide'));
    if (slides.length < 2) return;

    function update() {
      var slide = centeredSlide(scroller, slides);
      var height = naturalHeight(scroller, slide);
      if (height > 0) {
        scroller.style.height = height + 'px';
      }
    }

    // Importante: NO recalcular en cada evento de scroll mientras el dedo
    // todavia esta deslizando -- cambiar el alto del contenedor a mitad de
    // gesto interfiere con el calculo nativo de "a que diapositiva hacer
    // snap", y el swipe se pasaba de largo. Se espera a que el scroll se
    // asiente del todo antes de ajustar el alto.
    var settleTimer = null;

    function scheduleUpdate() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        update();
      }, 120);
    }

    update();

    if ('onscrollend' in window) {
      scroller.addEventListener('scrollend', update, { passive: true });
    } else {
      scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    }

    window.addEventListener('resize', scheduleUpdate);
  }

  function start() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    document
      .querySelectorAll('.product-information__media media-gallery')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
